import { COLORS } from '@elo-kit/constants/general.constants'

const { eloBlue } = COLORS

// TODO: update with using createUseStyles
const customStyles = (theme) => ({
  lessonPageRight: {
    background: '#FFFFFF !important',
    margin: `${theme.showLessonBanner === false ? 0 : 30}px 0 30px !important`,
    marginLeft: '30px !important',
    marginRight: `${theme.fullWidth ? 30 : 0}px !important`,
    width: 'calc(100% - 383px) !important',
    '& .white-widget': {
      margin: '30px 0 30px !important',
      boxShadow: 'unset',
      '&:first-child': {
        margin: '0 0 30px !important',
      },
      '&:last-child': {
        margin: '0 !important',
        padding: '0 0',

        '@media (max-width: 991px)': {
          padding: '30px 10px 0 !important',
        },
      },
    },
    '@media (max-width: 991px)': {
      width: 'calc(100% - 20px) !important',
      margin: '10px 10px 30px !important',
    },

    '& .mobile-comment-form': {
      '& .fa-times-circle': {
        color: theme.buttonColor || eloBlue,
      },
    },
  },
  lessonPageLeft: {
    background: '#FFFFFF !important',
    margin: `${theme.showLessonBanner === false ? 0 : 30}px 0 0 !important`,
    marginRight: '30px !important',
    marginLeft: `${theme.fullWidth ? 30 : 0}px !important`,
    '& .white-widget': {
      margin: '30px 0 30px !important',
      boxShadow: 'unset',

      '&:first-child': {
        margin: '0 0 30px !important',
      },
      '&:last-child': {
        margin: '0 !important',
        padding: '0 0',

        '@media (max-width: 991px)': {
          padding: '30px 10px 0 !important',
        },
      },
    },
    width: 'calc(100% - 383px) !important',
    '@media (max-width: 991px)': {
      width: 'calc(100% - 20px) !important',
      margin: '10px 10px 0px !important',
    },

    '& .mobile-comment-form': {
      '& .fa-times-circle': {
        color: theme.buttonColor || eloBlue,
      },
    },
  },
  lessonPage: {
    background: '#FFFFFF !important',
    padding: `${theme.fullWidth ? 30 : 0}px`,
    margin: `60px 0 30px !important`,
    width: '100% !important',
    '& .white-widget': {
      margin: '30px 0 !important',
      boxShadow: 'unset',
      '&:first-child': {
        margin: '0 0 30px !important',
      },
      '&:last-child': {
        margin: '0 !important',
        padding: '0 0',

        '@media (max-width: 991px)': {
          padding: '30px 10px 0 !important',
        },
      },
    },
    '@media (max-width: 991px)': {
      width: 'calc(100% - 20px) !important',
      margin: '10px 10px 30px !important',
      padding: '0 10px',
    },

    '& .mobile-comment-form': {
      '& .fa-times-circle': {
        color: theme.buttonColor || eloBlue,
      },
    },
  },
  contentContainer: {
    maxWidth: `${theme.fullWidth ? 'none' : '1140px'}`,
    margin: '0 auto !important',
    display: 'flex',

    '& .course-side-nav': {
      height: '100%',
      marginTop: `${!theme.topNavigationEnabled && !theme.showLessonBanner ? '0' : ''}`,
    },
  },
})

export default customStyles
